import { getEmojiAliases, getEmojiIndex } from '../data'
import type { EmojiData } from '../types'

export function getEmojiTitle(emojiId: string) {
  const emoji = Object.values(getEmojiIndex()).find(
    (emoji) => emoji.id === emojiId
  )
  return emoji?.name ?? emojiId.toUpperCase()
}

export function getEmojiNativeText(emoji: EmojiData) {
  return emoji.skins[0]?.native || ''
}

export function getEmojiByUnified(unified: string) {
  return Object.values(getEmojiIndex()).find((emoji) =>
    emoji.skins.some((e) => e?.unified.toUpperCase() === unified.toUpperCase())
  )
}

export function getEmojiByNative(native: string) {
  const unified = Array.from(native)
    .map((cp) => (cp.codePointAt(0) || '').toString(16))
    .join('-')
  return getEmojiByUnified(unified)
}

export function getEmojiById(id: string) {
  const aliasedId = getEmojiAliases()[id]
  return getEmojiIndex()[aliasedId ?? id]
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
